import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/shutdown/reason/record`,
    name: 'SHUTDOWN_REASON_RECORD_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
